import script from "./SearchResultMaterialDetails.vue?vue&type=script&lang=ts&setup=true"
export * from "./SearchResultMaterialDetails.vue?vue&type=script&lang=ts&setup=true"

import "./SearchResultMaterialDetails.vue?vue&type=style&index=0&id=0720763c&lang=less&scoped=true"

import exportComponent from "D:\\a\\1\\s\\src\\Bolia.Website\\clients\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0720763c"]])

export default __exports__